import { gql } from "@apollo/client"
import {
  ASSIGNED_TRIP_BOOKING_FRAG,
  ASSIGNED_TRIP_LIST_FRAG,
} from "./trip.fragments.gql"

export const ADD_BOOKING_TO_TRIP = gql`
  mutation addBookingToTrip(
    $plotCommodityId: ID!
    $requiredQuantity: Int!
    $tripUuid: String!
    $skuType: ID!
    $vehicleLat: Float
    $vehicleLon: Float
    $destinationDepot: ID!
    $sourceDepot: ID!
  ) {
    addNewBooking(
      sourceDepot: $sourceDepot
      destinationDepot: $destinationDepot
      plotCommodityId: $plotCommodityId
      requiredQuantity: $requiredQuantity
      tripUuid: $tripUuid
      skuType: $skuType
    ) {
      trip {
        ...AssignedTripListFrag
        unloadedBy {
          id
          name
        }
        optimisedBookings(vehicleLat: $vehicleLat, vehicleLon: $vehicleLon) {
          ...AssignedTripBookingFrag
        }
      }
    }
  }

  ${ASSIGNED_TRIP_LIST_FRAG}
  ${ASSIGNED_TRIP_BOOKING_FRAG}
`

export const UPDATE_BOOKING = gql`
  mutation UpdateBooking($updateBookings: [UpdateBookingInput]!) {
    updateBooking(updateBookings: $updateBookings) {
      bookings {
        id
        procuredQuantity
        requiredQuantity
      }
    }
  }
`
